import React from 'react';
import ProfileIcon from "../../assets/profile.png";

const PageList = ({pages, includes}) => {

    const author = {
        name: 'Sid Alwar',
        role: 'Co-Founder',
        href: '#'
    }

  function getAssetImageUrl(id) {
    const asset = includes.Asset.find(asset => asset.sys.id === id);
    if (asset) {
      return `https:${asset.fields.file.url}`;
    }
    return null;
  }


  return (
    <>
                      {pages.map((page) => (
                    <article key={page["fields"]["slug"]} className="flex flex-col items-start justify-between">
                      <div className="w-full">
                      <a href={"/blog/" + page["fields"]["slug"]} >
                        <img
                          alt=""
                          src={getAssetImageUrl(page["fields"]["coverImage"]["sys"]["id"])}
                          className="aspect-video w-full rounded-2xl bg-gray-100 object-cover sm:aspect-2/1 lg:aspect-3/2"
                        />
                        </a>
                        </div>
                      <div className="max-w-xl">
                        <div className="mt-8 flex items-center gap-x-4 text-xs">
                          <time dateTime={page["sys"]["updatedAt"]} className="text-gray-500">
                            {new Date(page["sys"]["updatedAt"]).toLocaleDateString('en-US', { month: 'short', year: 'numeric', day: 'numeric' })}
                          </time>
                          <a
                            href={"#"}
                            className="rounded-full bg-gray-50 px-3 py-1.5 font-medium text-gray-600 hover:bg-gray-100"
                          >
                            {page["metadata"]["tags"].map((tag) => (
                              <span key={tag["sys"]["id"]}>{tag["sys"]["id"]}</span>
                            ))}

                          </a>
                        </div>
                        <div className="group relative">
                        <a href={"/blog/" + page["fields"]["slug"]}>
                                <h3 className="mt-3 text-lg/6 font-semibold text-gray-900 group-hover:text-gray-600">

                              {page["fields"]["title"]}
                          </h3>
                          <p className="mt-5 line-clamp-3 text-sm/6 text-gray-600"> {page["fields"]["previewText"]}</p>
                        
                          </a>
                        </div>
                        <div className="relative mt-8 flex items-center gap-x-4" style={{ zIndex: 1 }}>
                          <img alt="" src={ProfileIcon} className="size-10 rounded-full bg-gray-100" />
                          <div className="text-sm/6">
                            <p className="font-semibold text-gray-900">
                                
                                {author.name}
                            </p>
                            <p className="text-gray-600">{author.role}</p>
                          </div>
                        </div>
                      </div>
                    </article>
                  ))}
    </>
  );
};

export default PageList;


